import React from 'react';
import Notification from './Notification';
import { connect } from 'react-redux';

const mapStateToProps= function(state) {
  return { notifications: state.notifications};
}

class NotificationWrapper extends React.Component{
  render(){
    return(
      <div>
        {this.props.notifications.map(item => (
          <Notification key={item.id} notification={item}></Notification>
        ))}
      </div>
    );
  }
}

export default connect(mapStateToProps)(NotificationWrapper);



// WEBPACK FOOTER //
// ./src/app/components/NotificationWrapper.jsx